import React from 'react';

const style = {
    animationDelay: '1s'
};
const CardWrapper = (props) => {
    return (
        <div style={style} className="app-review-containers animated flipInX">
            <div className="card">
                <div className="card-body">
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default CardWrapper;


// WEBPACK FOOTER //
// ./src/Review/CardWrapper.js